import { useState } from "react";
import { jsPDF } from "jspdf";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function PdfCreator() {
  const [text, setText] = useState("");
  const [font, setFont] = useState("Arial");

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imgTag = `<img src='${e.target.result}' style='max-width:100%;'/>`;
        setText((prevText) => prevText + imgTag);
      };
      reader.readAsDataURL(file);
    });
  };

  const generatePDF = () => {
    const pdf = new jsPDF();
    pdf.setFont(font);
    
    const editorContent = document.createElement("div");
    editorContent.innerHTML = text;
    
    let yOffset = 20;
    editorContent.childNodes.forEach((node) => {
      if (node.nodeName === "IMG") {
        pdf.addImage(node.src, "PNG", 10, yOffset, 100, 50);
        yOffset += 60;
      } else {
        pdf.text(node.textContent, 10, yOffset, { maxWidth: 180 });
        yOffset += 10;
      }
    });
    
    pdf.save("document.pdf");
  };

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h1 className="text-xl font-bold mb-4">Create Your PDF</h1>
      <ReactQuill value={text} onChange={setText} theme="snow" />
      
      <div className="mt-4 space-y-2">
        <label className="block font-semibold">Upload Images</label>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageUpload}
          className="border p-2 w-full"
        />
        
        <label className="block font-semibold">Select Font</label>
        <select
          value={font}
          onChange={(e) => setFont(e.target.value)}
          className="border p-2 w-full"
        >
          <option value="Arial">Arial</option>
          <option value="Times New Roman">Times New Roman</option>
          <option value="Courier New">Courier New</option>
        </select>
      </div>
      
      <button
        onClick={generatePDF}
        className="px-4 py-2 bg-blue-500 text-white rounded mt-4"
      >
        Generate PDF
      </button>
    </div>
  );
}
